import { render, staticRenderFns } from "./PicList.vue?vue&type=template&id=56b11faa&scoped=true"
import script from "./PicList.vue?vue&type=script&lang=js"
export * from "./PicList.vue?vue&type=script&lang=js"
import style0 from "./PicList.vue?vue&type=style&index=0&id=56b11faa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b11faa",
  null
  
)

export default component.exports